<template>
  <div class="flex flex-wrap gap-2 items-center mb-0">
    <div class="flex flex-row gap-2">
      <button
        class="px-5 py-1.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap border"
        :class="props.filter === 'all' ? 
        'bg-gray-900 text-white border-gray-900 shadow-md dark:bg-white dark:text-gray-900 dark:border-white' : 
        'bg-white text-gray-600 border-gray-200 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-700'"
        @click="updateFilter('all')">{{ $t('playlist.filterAll') }}</button>
      <button
        class="px-5 py-1.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap border"
        :class="props.filter === 'favorite' ? 
        'bg-gray-900 text-white border-gray-900 shadow-md dark:bg-white dark:text-gray-900 dark:border-white' : 
        'bg-white text-gray-600 border-gray-200 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-700'"
        @click="updateFilter('favorite')">{{ $t('playlist.filterFavorite') }}</button>
      <button
        class="px-5 py-1.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap border"
        :class="props.filter === 'newest' ? 
        'bg-gray-900 text-white border-gray-900 shadow-md dark:bg-white dark:text-gray-900 dark:border-white' : 
        'bg-white text-gray-600 border-gray-200 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-700'"
        @click="updateFilter('newest')">{{ $t('playlist.filterNewest') }}</button>
    </div>
    <div class="relative flex items-center">
        <MagnifyingGlassIcon class="w-4 h-4 text-gray-400 absolute left-3 pointer-events-none" />
        <input
          type="text"
          class="pl-9 pr-4 py-1.5 rounded-full border border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 text-gray-900 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 transition-colors duration-200 w-48 focus:w-64 shadow-sm hover:border-gray-300 dark:hover:border-gray-600"
          :placeholder="$t('playlist.searchPlaylists')"
          :value="props.search"
          @input="updateSearch($event.target.value)"
        />
    </div>
  </div>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import { MagnifyingGlassIcon } from '@heroicons/vue/24/outline'

const props = defineProps({
  search: String,
  filter: String
})

const emit = defineEmits(['update:filter', 'update:search'])  

function updateFilter(value) {
  emit('update:filter', value)
}

function updateSearch(value) {
  emit('update:search', value)
}
</script> 